import React from 'react';
import { isEmpty } from 'lodash';
import CommonCollapsibleCard from 'components/CommonCollapsibleCard/CommonCollapsibleCard';
import { PAGE_VIEW_EVENT_NAME } from 'modules/PixelTester/config/pixelTesterConsts';
import { CONVERSION_TYPE } from 'modules/tracking/config';
import { EventCardHeader } from './components/EventCardHeader/EventCardHeader';
import { EventData } from './components/EventData/EventData';
import { UnrecognisedEventDescription } from './components/UnrecognisedEventDescription/UnrecognisedEventDescription';
import styles from './event.module.scss';

export const Event = ({ eventData }) => {
    if (!eventData) {
        return null;
    }
    const { id, eventName, matchedRules = [] } = eventData;
    const eventType = matchedRules?.[0]?.type ?? CONVERSION_TYPE.EVENT_BASED;
    const conversionName = matchedRules?.[0]?.conversionName;
    const hasConversions = !isEmpty(matchedRules);
    const isAutomaticallyFired = !hasConversions && eventName === PAGE_VIEW_EVENT_NAME;
    const showDescription = !hasConversions && !isAutomaticallyFired;

    return (
        <CommonCollapsibleCard
            bodyClassName={styles['card-body']}
            headerClassName={styles['card-header']}
            containerClassName={styles['card-container']}
            descriptionClassName={styles['description']}
            id={`PIXEL_TESTER_EVENT_${conversionName}_${id}`}
            isInitiallyCollapsed
            header={
                <EventCardHeader
                    conversionName={conversionName}
                    eventType={eventType}
                    eventData={eventData}
                    hasConversions={hasConversions}
                    isAutomaticallyFired={isAutomaticallyFired}
                />
            }
            description={showDescription ? <UnrecognisedEventDescription /> : null}
        >
            <EventData eventData={eventData} eventType={eventType} />
        </CommonCollapsibleCard>
    );
};
